import MediaQuery from 'react-responsive'
import Video from '../components/video';
import VideoIntersection from '../components/videoIntersection';
import Wave1 from '../components/waves/wave1';
import Wave1Mobile from '../components/waves/wave1mobile';
import Key1 from '../components/keys/key1';
import Key1Mobile from '../components/keys/key1mobile';
import Key2 from '../components/keys/key2';

function Hero({animate}) {
   const mobileVideo="/ReactAssets/CustomerJourney/MILLER_MAIN_MOB.mp4";
   const desktopVideo="/ReactAssets/CustomerJourney/MILLER_MAIN.mp4";
   const coffeeVideo = "/ReactAssets/CustomerJourney/COFFEE_MAIN.mp4";
   const loadingPoster = '/ReactAssets/CustomerJourney/loading.gif';
   return (
      <div className="hero">
         <div className={`cloud cloud--1 ${animate ? '' : 'animation-off'}`}></div>
         <div key={animate} className={`cloud cloud--2 ${animate ? '' : 'animation-off'}`}></div>
         <div className="hero__content">
            <div>
               <h1>Your adventure awaits...</h1>
               <p>Let us guide you on a journey through the exciting experience of buying a brand-new Miller home. We want you to enjoy every single minute. We’ve been experts at building homes for over 85 years and are rated 5 stars for customer satisfaction, so you can rest assured we’ll be with you every step of the way. <strong>Let your new adventure begin.</strong></p>
               <svg className={`chevron ${animate ? '' : 'animation-off'}`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                  <g id="Group_677" data-name="Group 677" transform="translate(-636 -8690)">
                     <path id="Path_542" data-name="Path 542" d="M6037.646,2182.378,6049,2193.89l10.963-11.511" transform="translate(-5389 6527)" fill="none" stroke="#a39161" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                     <g id="Ellipse_562" data-name="Ellipse 562" transform="translate(636 8690)" fill="none" stroke="#a39161" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <circle cx="24" cy="24" r="24" stroke="none"/>
                        <circle cx="24" cy="24" r="23" fill="none"/>
                     </g>
                  </g>
               </svg>

            </div>
         </div>
            <MediaQuery minWidth={768}>
               <Video src={desktopVideo} name="hero" poster={loadingPoster} animate={animate} hero loop/>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
               <Video src={mobileVideo} name="hero" poster={loadingPoster} animate={animate} hero loop/>
            </MediaQuery>
            <div className="bg-sand hero__keys">
            <MediaQuery minWidth={768}>
               <Key1 animate={animate}/>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
               <Key1Mobile animate={animate}/>
            </MediaQuery>
         </div>
         <div className="bg-sand ">
            <div className="flex">
               <div className="col-1/2">
                  <VideoIntersection 
                  animate={animate} 
                  poster={loadingPoster}
                  src={coffeeVideo} 
                  loop/>
               </div>
               <div className="col-1/2 px-15">
                  <h2>Stay in the loop</h2>
                  <p>To start your search, first register your details on our website or download our app. 
                     From here, you can save all your favourite developments, book appointments to visit 
                     and we can easily keep you updated when plots are released for sale. And when you have 
                     found your new home, you can even begin your pre-reservation online if you want to.</p>
                  <ul>
                     <li>Save your favourite plots and developments</li>
                     <li>Receive exclusive email and text alerts on new homes</li>
                     <li>Book appointments</li>
                     <li>Pre-reserve your new home online</li>
                  </ul>
                  <a href="/what-makes-us-different/my-miller-home.aspx" className="btn btn-primary">Register for My Miller Home</a>
               </div>
            </div>
         </div>
         <MediaQuery minWidth={768}>
            <div className="bg-sand hero__keys">
               <Key2 animate={animate}/>
            </div> 
         </MediaQuery>
         <div className="bg-sand wave">
            <MediaQuery minWidth={768}>
               <Wave1 flip/>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
               <Wave1Mobile />
            </MediaQuery>
         </div>
      </div>
   );
 }
 //          

 export default Hero;